import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import ProtectedButton from '../../containers/protected-button';
import LikeButton from '../like-button';
import PostSocialActions from '../../containers/post-social-actions';
import { HorizontalSeparator, VerticalSeparator } from '../separator';
import { showShare } from '../../services/show-share';
import withDeviceType from '../../hoc/with-device-type';
import withPermissions from '../../hoc/with-permissions';
import withTranslate from '../../hoc/with-translate';
import withAuth from '../../hoc/with-auth';
import styles from './post-main-actions.scss';

const PostMainActions = ({ can, category, post, onShareClick, onLikeClick, isDesktop, isMobile, t, forPublicUser }) => {
  const canShare = can('share', 'post', post) && showShare();
  const likeCount = post.likeCount || 0;

  return (
    <div className={styles.container}>
      {isMobile && <HorizontalSeparator/>}
      <div className={styles.buttonContainer}>
        {canShare && isDesktop && <PostSocialActions path={`/${category.slug}/${post.slug}`}/>}
        {canShare &&
          !isDesktop &&
          <button className={styles.button} onClick={onShareClick}>
            <span className={styles.buttonWrapper}>
              {t('post-main-actions.share')}
            </span>
          </button>}
        {canShare && isMobile && <VerticalSeparator/>}
        <ProtectedButton className={styles.button} onClick={forPublicUser(onLikeClick)} aria-live="assertive">
          <span className={styles.buttonWrapper}>
            <span className={classNames(styles.likeCount, 'post-main-actions__like-count')} data-hook="post-main-actions__like-count">
              {t('post-main-actions.like-count', { count: likeCount })}
            </span>
            <LikeButton isLiked={post.isLiked} likeCount={likeCount} isDisabled={post.isLikeInProgress}/>
          </span>
        </ProtectedButton>
      </div>
      {isMobile && <HorizontalSeparator/>}
    </div>
  );
};

PostMainActions.propTypes = {
  category: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  onShareClick: PropTypes.func.isRequired,
  onLikeClick: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool,
  isMobile: PropTypes.bool,
  can: PropTypes.func,
  t: PropTypes.func,
  forPublicUser: PropTypes.func,
};

export default flowRight(
  withDeviceType,
  withPermissions,
  withTranslate,
  withAuth,
)(PostMainActions);



// WEBPACK FOOTER //
// ./app/components/post-main-actions/post-main-actions.js